import React, { useState, useEffect } from "react";

import { motion } from "framer-motion";
import { urlFor, client } from "../../client";
import { AppWrap, MotionWrap } from "../../wrapper";
import { saveAs } from "file-saver";
import "./About.scss";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => setAbouts(data));
  }, []);

  const saveFile = () => {
    saveAs(
      "https://drive.google.com/file/d/1BGBy19V7RMS_KyPC-_UzxJVOK9tWsOqh/view?usp=sharing",
      "Abhijeet__Frontend__Dev.pdf"
    );
  };

  const handleLinkedIn =  () => {
    window.open("https://www.linkedin.com/in/abhijeet390/");

  }

  const handleGithub =  () => {
    window.open("https://github.com/Codingtech390");

  }

  return (
    <>
      <div className=" app__flex " >
        <p className=" intro-text">
          <span>I</span> am a passionate{" "}
          <span>Full Stack Software Developer</span> 🚀 having a special
          interest <br /> in <span>Frontend technologies </span>
          and experience of building Web applications <br /> with{" "}
          <span>JavaScript / Reactjs / Nodejs</span> <br /> and some other cool{" "}
          <span>libraries</span> and <span>frameworks</span>.
        </p>
      </div>

      <div className="app__flex button-container">
        <a href="../../assets/Abhijeet__Frontend__Dev.pdf">
          <button className="button" onClick={saveFile}>
            Download my CV
          </button>
        </a>
        <button
          className="button"
          onClick={ handleLinkedIn}
        >
          Let's connect on Linked-in
        </button>
        <button
          className="button"
          onClick={handleGithub}

        >
          Let's code on Github
        </button>
      </div>

      <h2 className="head-text">
        I Know That <span>Good Apps</span> <br /> means{" "}
        <span>Good Business</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
